export const CourseActionTypes = {
    GET_TRAINING_DATA_BY_LOCATION: "GET_TRAINING_DATA_BY_LOCATION",
    GET_COUNTRY_STATE_WISE_DATA: "GET_COUNTRY_STATE_WISE_DATA",
    STATE_WISE_META_INFORMATION: "STATE_WISE_META_INFORMATION"
};